import React from "react"
import loadable from "@loadable/component"

export default {
  component: loadable(
    () => import(/* webpackChunkName: "DeliveryBoy" */ "./DeliveryBoy"),
    {
      fallback: <div>Loading...</div>,
    }
  )
}
